import React from 'react';
import { Link } from 'react-router-dom';
import VideoModal from '../VideoModal';

export default function HeroStyle2({
  title,
  subTitle,
  bgUrl,
  imgUrl,
  videoBtnText,
  videoUrl,
  funfactList,
  btnText,
  btnUrl,
}) {
  return (
    <section
      className="cs_hero cs_style_2 cs_bg_filed"
      style={{ backgroundImage: `url(${bgUrl})`}}
    >
      <div className="container row">
        <div className="cs_hero_text col-sm-12 col-md-6">
          <h1 className="cs_hero_title cs_white_color fs-hero-title">{title}</h1>
          <div className="d-flex flex-column gap-2">
            <div className="cs_hero_btn cs_white_color ">
              <Link to={btnUrl} className="cs_text_btn">
                {btnText}
              </Link>
            </div>
            <p className="cs_hero_subtitle cs_white_color">{subTitle}</p>
          </div>
        </div>
        <div className='col-md-6 d-none d-md-block'>
        <img src={imgUrl} alt="Hero" className="cs_hero_patents floating-exp" />
        </div>
      </div>
      <div className="container">
        <div className="cs_hero_bottom">
          <div className="cs_hero_bottom_left">
            <div className="cs_hero_btn_wrap">
              {/* <VideoModal
                videoUrl={videoUrl}
                videoBtnText={videoBtnText}
                variant="cs_white_color"
              /> */}
            </div>
          </div>
          <div className="cs_hero_bottom_right">
            {funfactList?.length > 0 && (
              <div className="cs_hero_funfact text-center">
                {funfactList?.map((item, index) => (
                  <div className="cs_hero_funfact_col" key={index}>
                    <h3 className="cs_white_color cs_fs_72">{item.number}</h3>
                    <p className="cs_white_color mb-0">{item.title}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
